import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Lock, X } from 'lucide-react';

interface BloqueadaFilterProps {
  bloqueadaFilter: string;
  onBloqueadaFilterChange: (filter: string) => void;
  onClearFilter: () => void;
}

const BloqueadaFilter: React.FC<BloqueadaFilterProps> = ({
  bloqueadaFilter,
  onBloqueadaFilterChange,
  onClearFilter,
}) => {
  return (
    <div className="flex flex-col gap-3 p-4 bg-gray-50 rounded-lg border">
      <div className="flex items-center gap-2">
        <Lock className="h-4 w-4" />
        <span className="text-sm font-medium">Filtro por bloqueo</span>
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex flex-col gap-2">
          <label className="text-xs font-medium text-gray-600">Estado de bloqueo</label>
          <Select value={bloqueadaFilter || 'todos'} onValueChange={onBloqueadaFilterChange}>
            <SelectTrigger className="w-full sm:w-48">
              <SelectValue placeholder="Seleccionar" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="todos">Todos</SelectItem>
              <SelectItem value="si">Bloqueadas</SelectItem>
              <SelectItem value="no">No bloqueadas</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-xs font-medium text-gray-600 invisible">Acciones</label>
          <div className="flex gap-2">
            <Button
              onClick={onClearFilter}
              variant="outline"
              size="sm"
              className="px-3"
              disabled={!bloqueadaFilter || bloqueadaFilter === 'todos'}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BloqueadaFilter;
